<div class="container-fluid mb-5">
    <div class="row">
        <app-speed-dial-fab (clicked)="dispatch($event)" [options]="FabOptions"></app-speed-dial-fab>
        <div class="col-12 my-1">
            <div class="border rounded-1 background-light p-3">
                <!-- <h5 class="card-header">Localisation</h5> -->
                <div class="row">
                    <h2 class="col text-center fw-bold"> Localisation</h2>
                </div>
                <div class="row">

                    <div class="row text-center">
                        <div class="col fw-bold">
                            Amont
                        </div>
                    </div>
                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>X</mat-label>
                            <input matInput placeholder="X" type="number" [(ngModel)]="MGCEProcess.LocalisationStation.Amont.L93X"
                                   [formControl]="IsAmontX2FarControl"
                                   (keyup)="onAmontXKeyUpEvent($event)">
                            <mat-error *ngIf="IsAmontX2FarControl.hasError('pattern')">
                                Format erroné. 6 chiffres uniquement !
                            </mat-error>
                            <mat-error *ngIf="!IsAmontX2FarControl.valid && !IsAmontX2FarControl.hasError('pattern')">
                                Ecart > 500
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>Y</mat-label>
                            <input matInput placeholder="Y" type="number" [(ngModel)]="MGCEProcess.LocalisationStation.Amont.L93Y"
                                   [formControl]="IsAmontY2FarControl"
                                   (keyup)="onAmontYKeyUpEvent($event)">
                            <mat-error *ngIf="IsAmontY2FarControl.hasError('pattern')">
                                Format erroné. 7 chiffres uniquement !
                            </mat-error>
                            <mat-error *ngIf="!IsAmontY2FarControl.valid && !IsAmontY2FarControl.hasError('pattern')">
                                Ecart > 500
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">

                    <div class="row text-center">
                        <div class="col fw-bold">
                            Aval
                        </div>
                    </div>
                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>X</mat-label>
                            <input matInput placeholder="X" type="number" [(ngModel)]="MGCEProcess.LocalisationStation.Aval.L93X"
                                   [formControl]="IsAvalX2FarControl"
                                   (keyup)="onAvalXKeyUpEvent($event)">
                            <mat-error *ngIf="IsAvalX2FarControl.hasError('pattern')">
                                Format erroné. 6 chiffres uniquement !
                            </mat-error>
                            <mat-error *ngIf="!IsAvalX2FarControl.valid && !IsAvalX2FarControl.hasError('pattern')">
                                Ecart > 500
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>Y</mat-label>
                            <input matInput placeholder="Y" type="number" [(ngModel)]="MGCEProcess.LocalisationStation.Aval.L93Y"
                                   [formControl]="IsAvalY2FarControl"
                                   (keyup)="onAvalYKeyUpEvent($event)">
                            <mat-error *ngIf="IsAvalY2FarControl.hasError('pattern')">
                                Format erroné. 7 chiffres uniquement !
                            </mat-error>
                            <mat-error *ngIf="!IsAvalY2FarControl.valid && !IsAvalY2FarControl.hasError('pattern')">
                                Ecart > 500
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="row text-center">
                        <div class="col fw-bold">
                            Commentaire
                        </div>
                    </div>
                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>Limite Amont</mat-label>
                            <input matInput placeholder="Limite Amont" [(ngModel)]="MGCEProcess.LocalisationStation.LimiteAmont"
                                   [formControl]="ValidAmontMaxLength">
                            <mat-hint align="end">{{MGCEProcess.LocalisationStation.LimiteAmont?.length || 0}}/{{COMMENT_MAX_SIZE}}</mat-hint>
                            <mat-error *ngIf="ValidAmontMaxLength.hasError('maxlength')">
                                Texte trop long
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>Limite Aval</mat-label>
                            <input matInput placeholder="Limite Aval" [(ngModel)]="MGCEProcess.LocalisationStation.LimiteAval"
                                   [formControl]="ValidAvalMaxLength">
                            <mat-hint align="end">{{MGCEProcess.LocalisationStation.LimiteAval?.length || 0}}/{{COMMENT_MAX_SIZE}}</mat-hint>
                            <mat-error *ngIf="ValidAvalMaxLength.hasError('maxlength')">
                                Texte trop long
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

            </div>
        </div>

        <div class="col-12 my-1">
            <div class="border rounded-1 background-light p-3">
                <!-- <h5 class="card-header">Positionnement de la station</h5> -->
                <div class="row">
                    <h2 class="col text-center fw-bold"> Positionnement de la station</h2>
                </div>

                <div class="row ">
                    <div class="col">
                        LpB moy {{computeLpBMoy() | number: '1.1-1'}}
                    </div>
                    <div class="col">
                        Lt calculée {{computeLtCalculee() | number: '1.1-1'}}
                    </div>
                    <div class="col">
                        Lm moy {{computeLmMoy() | number: '1.1-1'}}
                    </div>

                    <div class="col">
                        Smouillée {{computeSmouille() | number: '1.1-2'}}
                    </div>
                    <div class="col">
                        Smax {{computeSmaxMarg() | number: '1.1-2'}}
                    </div>

                    <div class="col">
                        Pmax {{computePmax() | number: '1.1-2'}}
                    </div>
                    <div class="col">
                        Lmax ZB {{computeLmaxZB() | number: '1.1-1'}}
                    </div>
                    <div class="col">
                        Profondeur Limite ZiZp {{computePLimitZiZp() | number: '1.1-2'}}
                    </div>
                </div>
                <!-- <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <input matInput placeholder="Lpb Moyennne" type="number" [(ngModel)]="MGCEProcess.MGCEMesureStation.LpbMoyenne">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <input matInput placeholder="Lm Moyenne" type="number" [(ngModel)]="MGCEProcess.MGCEMesureStation.LmMoyenne">
                            </mat-form-field>
                        </div>
                    </div> -->
                <div class="row">
                    <!-- <div class="col-6">
                            <mat-form-field class="w-100">
                                <input matInput placeholder="Smouillee" type="number" [(ngModel)]="MGCEProcess.MGCEMesureStation.Smouillee">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <input matInput placeholder="Lmax Zone Berge" type="number" [(ngModel)]="MGCEProcess.MGCEMesureStation.LmaxZoneBerge">
                            </mat-form-field>
                        </div> -->
                    <div class="col-6">
                        <mat-form-field class="w-100">
                            <mat-label>Mode Mesure</mat-label>
                            <mat-select placeholder="Mode Mesure" [(ngModel)]="MGCEProcess.MGCEMesureStation.ModeMesure" required>
                                <mat-option *ngFor="let p of ModeMesureList; let i = index" [value]="i + 1">
                                    <span>{{p}}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <!-- <div class="col-6">
                            <mat-form-field class="w-100">
                                <input matInput placeholder="Profondeur Limite ZiZp" type="number"
                                       [(ngModel)]="MGCEProcess.MGCEMesureStation.ProfondeurLimiteZiZp">
                            </mat-form-field>
                        </div> -->

                    <!-- <div class="col-6">
                            <mat-form-field class="w-100">
                                <input matInput placeholder="Longueur Station" type="number" [(ngModel)]="MGCEProcess.MGCEMesureStation.LongueurStation">
                            </mat-form-field>
                        </div> -->
                    <div class="col-6">
                        <mat-form-field class="w-100">
                            <mat-label>Lt Réelle</mat-label>
                            <input matInput placeholder="Lt Réelle" type="number" [(ngModel)]="MGCEProcess.MGCEMesureStation.LtReelle">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mt-3">
                    <h6 class="d-flex align-items-center m-0 col-auto">Largueur de la station</h6>

                    <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="openMesureBox()">
                        <mat-icon>add</mat-icon>
                    </button>

                </div>
                <div class="row mt-3 justify-content-center">
                    <div *ngFor="let largueur of MGCEProcess.MGCEMesureStation.LargeurStations; let i = index" class="col-auto">
                        <div class="border rounded-pill p-3 py-5 m-1">

                            <div class="row justify-content-center">
                                <div class="col-10">
                                    <mat-form-field class="w-100">
                                        <input matInput [placeholder]="getLpB(i)" type="number" [(ngModel)]="largueur.LpB" disabled="true">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-10">
                                    <mat-form-field class="w-100">
                                        <input matInput [placeholder]="getLm(i)" type="number" [(ngModel)]="largueur.Lm" disabled="true">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="p-0 d-flex justify-content-center">
                                <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="openMesureBox(largueur)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="removeLargeur(largueur)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <h6 class="d-flex align-items-center m-0 col-auto">Transect</h6>

                    <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="addTransect()" [disabled]="!CanAddTransect()">
                        <mat-icon>add</mat-icon>
                    </button>

                </div>
                <div class="row mt-3 ">
                    <div *ngFor="let transect of MGCEProcess.MGCETransectList; let i = index" class="col-12 col-md-6">
                        <div class="row justify-content-center">
                            <div class="col-12">
                                <div class="row justify-content-center">
                                    <div class="col-auto">
                                        <button appPreventDoubleClick [throttleTime]="200" mat-raised-button color="accent" (throttledClick)="openTransectMesureBox(transect)">
                                            <mat-icon>add</mat-icon> Nouvelle mesure
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div *ngFor="let mesure of transect.TransectMesureList; let i = index" class="col-auto">
                                <div class="border rounded-pill p-3 py-5 m-1">

                                    <div class="row justify-content-center">
                                        <div class="col-10">
                                            <mat-form-field class="w-100">
                                                <mat-label>Distance Rive</mat-label>
                                                <input matInput placeholder="Distance Rive" type="number" [(ngModel)]="mesure.DistanceRive" disabled="true">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row justify-content-center">
                                        <div class="col-10">
                                            <mat-form-field class="w-100">
                                                <mat-label>Profondeur</mat-label>
                                                <input matInput placeholder="Profondeur" type="number" [(ngModel)]="mesure.Profondeur" disabled="true">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="p-0 d-flex justify-content-center">
                                        <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="openTransectMesureBox(transect, mesure)">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                        <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="removeTransectMesure(transect, mesure)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <mat-form-field class="d-block m-auto">
                                    <mat-label>Lm</mat-label>
                                    <input matInput placeholder="Lm" type="number" [(ngModel)]="transect.Lm">
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field class="d-block m-auto">
                                    <mat-label>Distance Limite Aval</mat-label>
                                    <input matInput placeholder="Distance Limite Aval" type="number" [(ngModel)]="transect.DistanceLimiteAval" >
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field class="d-block m-auto">
                                    <mat-label>Distance RGZBZI</mat-label>
                                    <input matInput placeholder="Distance RGZBZI" type="number" [(ngModel)]="transect.DistanceRGZBZI" readonly>
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field class="d-block m-auto">
                                    <mat-label>Distance RDZBZI</mat-label>
                                    <input matInput placeholder="Distance RDZBZI" type="number" [(ngModel)]="transect.DistanceRDZBZI" readonly>
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field class="d-block m-auto">
                                    <mat-label>Distance RGZIAZINA</mat-label>
                                    <input matInput placeholder="Distance RGZIAZINA" type="number" [(ngModel)]="transect.DistanceRGZIAZINA" readonly>
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field class="d-block m-auto">
                                    <mat-label>Distance RDZIAZINA</mat-label>
                                    <input matInput placeholder="Distance RDZIAZINA" type="number" [(ngModel)]="transect.DistanceRDZIAZINA" readonly>
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field class="d-block m-auto">
                                    <mat-label>Distance RGZIZP</mat-label>
                                    <input matInput placeholder="Distance RGZIZP" type="number" [(ngModel)]="transect.DistanceRGZIZP" readonly>
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field class="d-block m-auto">
                                    <mat-label>Distance RDZIZP</mat-label>
                                    <input matInput placeholder="Distance RDZIZP" type="number" [(ngModel)]="transect.DistanceRDZIZP" readonly>
                                </mat-form-field>
                            </div>

                            <div class="col-6">
                                <mat-form-field class="d-block m-auto">
                                    <mat-label>Commentaire</mat-label>
                                    <input matInput placeholder="Commentaire" [(ngModel)]="transect.Commentaire">
                                </mat-form-field>
                            </div>

                            <div class="row text-center">

                                <div class="col">
                                    Pmax {{computePMaxByTransect(transect) | number: '1.1-2'}}
                                </div>
                                <div class="col">
                                    Pmax Limit ZiZp {{computePLimitZiZpByTransect(transect) | number: '1.1-1'}}
                                </div>
                                <div class="col">
                                    5% Lm {{computeLmByTransect(transect) | number: '1.1-1'}}
                                </div>
                            </div>
                        </div>
                        <mat-divider *ngIf="coreData.IsMobile" class="my-3 w-50 m-auto"></mat-divider>
                    </div>
                </div>

            </div>
        </div>

        <div class="col-12 my-1">
            <div class="border rounded-1 background-light p-3">
                <!-- <h5 class="card-header">Substrat</h5> -->
                <div class="row">
                    <h2 class="col text-center fw-bold"> Substrat</h2>
                </div>

                <!-- <div class="row">
                        <div class="col-6 col-md-3">
                            <mat-form-field class="w-100">
                                <input matInput type="number" placeholder="% Recouvrement Zone Berge" [ngModel]="MGCEProcess.RecouvrementZoneBerge">
                            </mat-form-field>
                        </div>
                        <div class="col-6 col-md-3">
                            <mat-form-field class="w-100">
                                <input matInput type="number" placeholder="% Recouvrement ZI Accessible" [ngModel]="MGCEProcess.RecouvrementZIAccessible">
                            </mat-form-field>
                        </div>
                        <div class="col-6 col-md-3">
                            <mat-form-field class="w-100">
                                <input matInput type="number" placeholder="% Recouvrement ZI Non Accessible" [ngModel]="MGCEProcess.RecouvrementZINonAccessible">
                            </mat-form-field>
                        </div>
                        <div class="col-6 col-md-3">
                            <mat-form-field class="w-100">
                                <input matInput type="number" placeholder="% Recouvrement Zone Profonde" [ngModel]="MGCEProcess.RecouvrementZoneProfonde">
                            </mat-form-field>
                        </div>
                    </div> -->
                <div *ngFor="let sub of MGCEProcess.MGCESubstratList" class="row mt-3">
                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>Numéro Prélèvement</mat-label>
                            <input matInput placeholder="Numéro Prélèvement" [ngModel]="sub?.Prelevement?.Numero" readonly="">
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>Substrat</mat-label>
                            <input matInput placeholder="Substrat" [ngModel]="getSubstratName(sub.Type)" readonly="">
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>Zone</mat-label>
                            <input matInput placeholder="Zone" [ngModel]="getZoneName(sub.Zone)" readonly="">
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>Importance</mat-label>
                            <input matInput placeholder="Importance" [ngModel]="getImportanceName(sub.Importance)" readonly="">
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-auto justify-content-center d-flex">

                        <button appPreventDoubleClick mat-mini-fab color="warn" (throttledClick)="deleteSubstrat(sub)">
                            <mat-icon aria-label="delete">delete</mat-icon>
                        </button>
                        <button appPreventDoubleClick mat-mini-fab color="accent" (throttledClick)="openPrelevementDialog(sub)">
                            <mat-icon aria-label="add">science</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row justify-content-center mt-3">

                    <div class="col-auto">
                        <button appPreventDoubleClick class="col-12" mat-raised-button color="primary" (throttledClick)="openMGCESubstratDialog()">
                            <mat-icon aria-label="add">add</mat-icon> Nouveau substrat
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>